<template>
    <span class="text-primary">
        <i
            class="fa fa-download fa-lg icon-button"
            title="Download"
            @click.stop="downloadAnexo()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        anexo: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    methods: {
        downloadAnexo() {
            this.$store.dispatch('addRequest')
            this.servicos
                .obterAnexo(
                    this.anexo.projetoId,
                    this.anexo.projetoAnexoId
                )
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download do anexo!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                this.anexo.nomeArquivoOriginal
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
